export default __webpack_public_path__ + "static/media/risk-block-user.047d3082.png";